import {
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import conf from "config-dlm";
import ErrorChip from "components/utils/ErrorChip";
import JsonModal from "components/utils/Json";
import VirtualChip from "components/utils/VirtualChip";
import { isFound, useSmartContent } from "components/utils/SmartCell";
import { ProjectConfigSchema, Snapshot, usePavmLive } from "hooks/pavm/base";

const HostRow = (props: {
  open: boolean;
  data: Snapshot["base"];
  config: ProjectConfigSchema;
  version: string;
  updatedAt: Date | string | number | undefined;
}) => {
  const { open, config, data } = props;

  const { fan, powerSupply1, powerSupply2, productName, systemVersion } = data;
  const host = config.host;
  const virtual = config.hardware === "virtual";

  const live = usePavmLive(host);
  const error = live?.error?.response?.data?.message;

  const ProductName = useSmartContent(productName?.data);
  const SystemVersion = useSmartContent(systemVersion?.data);
  const Fan = virtual ? VirtualChip(fan?.data) : useSmartContent(fan?.data);
  const PowerSupply1 = virtual
    ? VirtualChip(powerSupply1?.data)
    : useSmartContent(powerSupply1?.data);
  const PowerSupply2 = virtual
    ? VirtualChip(powerSupply2?.data)
    : useSmartContent(powerSupply2?.data);

  return (
    <TableRow
      sx={{
        bgcolor: (theme) =>
          theme.palette.mode === "light" ? "primary.light" : "primary.dark",
      }}
    >
      <TableCell colSpan={10}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Table size="small" aria-label={`${host}-base`}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ color: "text.secondary" }}>
                  <b>Host</b>
                </TableCell>

                {conf.COLUMNS.HOST.map((column: string) => (
                  <TableCell key={column} align="right">
                    <b>{column}</b>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow key={`${host}-info`} sx={conf.LAST_CHILD_NO_BORDER}>
                <TableCell />

                <TableCell align="right">
                  {isFound(productName?.data) ? (
                    ProductName
                  ) : (
                    <ErrorChip
                      size="small"
                      placement="bottom"
                      info={productName?.error ?? "No data found"}
                    />
                  )}
                </TableCell>

                <TableCell align="right">
                  {isFound(systemVersion?.data) ? (
                    SystemVersion
                  ) : (
                    <ErrorChip
                      size="small"
                      info={systemVersion?.error ?? "No data found"}
                    />
                  )}
                </TableCell>

                <TableCell align="right">
                  {isFound(fan?.data) ? (
                    Fan
                  ) : (
                    <ErrorChip
                      size="small"
                      info={fan?.error ?? "No data found"}
                    />
                  )}
                </TableCell>

                <TableCell align="right">
                  {isFound(powerSupply1?.data) ? (
                    PowerSupply1
                  ) : (
                    <ErrorChip
                      size="small"
                      info={powerSupply1?.error ?? "No data found"}
                    />
                  )}
                </TableCell>

                <TableCell align="right">
                  {isFound(powerSupply2?.data) ? (
                    PowerSupply2
                  ) : (
                    <ErrorChip
                      size="small"
                      info={powerSupply2?.error ?? "No data found"}
                    />
                  )}
                </TableCell>

                <TableCell align="right">
                  <JsonModal type="Host" title={host} data={data} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default HostRow;
